import l from "@babel/runtime/helpers/esm/objectSpread2";
import d from "@babel/runtime/helpers/esm/slicedToArray";
import { sstyled as v } from "@semcore/utils/lib/core/index";
import e from "react";
import { createBaseComponent as k, sstyled as x } from "@semcore/core";
import X from "./Animation.mjs";
import { useForkRef as Y } from "@semcore/utils/lib/ref";
var o = (
  /*__reshadow_css_start__*/
  (v.insert(
    /*__inner_css_start__*/
    "@keyframes collapse-enter_2c217{0%,to{overflow:clip}}@keyframes collapse-exit_2c217{0%,to{overflow:clip}}@keyframes fade-in-out-enter_2c217{0%{opacity:0}to{opacity:1}}@keyframes fade-in-out-exit_2c217{0%{opacity:1}to{opacity:0}}@keyframes opacity-in_2c217{0%{opacity:0}to{opacity:1}}@keyframes opacity-out_2c217{0%{opacity:1}to{opacity:0}}@keyframes scale-left-in_2c217{0%{opacity:0;transform:translateX(20px) scaleX(.9);pointer-events:none}to{opacity:1;transform:translateX(0) scaleX(1);pointer-events:all}}@keyframes scale-right-in_2c217{0%{opacity:0;transform:translateX(-20px) scaleX(.9);pointer-events:none}to{opacity:1;transform:translateX(0) scaleX(1);pointer-events:all}}@keyframes scale-top-in_2c217{0%{opacity:0;transform:translateY(20px) scaleY(.9);pointer-events:none}to{opacity:1;transform:translateY(0) scaleY(1);pointer-events:all}}@keyframes scale-bottom-in_2c217{0%{opacity:0;transform:translateY(-20px) scaleY(.9);pointer-events:none}to{opacity:1;transform:translateY(0) scaleY(1);pointer-events:all}}@keyframes scale-left-out_2c217{to{opacity:0;transform:translateX(20px) scaleX(.9);pointer-events:none}0%{opacity:1;transform:translateX(0) scaleX(1);pointer-events:all}}@keyframes scale-right-out_2c217{to{opacity:0;transform:translateX(-20px) scaleX(.9);pointer-events:none}0%{opacity:1;transform:translateX(0) scaleX(1);pointer-events:all}}@keyframes scale-top-out_2c217{to{opacity:0;transform:translateY(20px) scaleY(.9);pointer-events:none}0%{opacity:1;transform:translateY(0) scaleY(1);pointer-events:all}}@keyframes scale-bottom-out_2c217{to{opacity:0;transform:translateY(-20px) scaleY(.9);pointer-events:none}0%{opacity:1;transform:translateY(0) scaleY(1);pointer-events:all}}@keyframes slide-top-in_2c217{0%{opacity:0;transform:translateY(-100px)}to{opacity:1;transform:translateY(0)}}@keyframes slide-top-out_2c217{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(-100px)}}@keyframes slide-bottom-in_2c217{0%{opacity:0;transform:translateY(100px)}to{opacity:1;transform:translateY(0)}}@keyframes slide-bottom-out_2c217{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(100px)}}@keyframes slide-left-in_2c217{0%{opacity:0;transform:translateX(-100px)}to{opacity:1;transform:translateX(0)}}@keyframes slide-left-out_2c217{0%{opacity:1;transform:translateX(0)}to{opacity:0;transform:translateX(-100px)}}@keyframes slide-right-in_2c217{0%{opacity:0;transform:translateX(100px)}to{opacity:1;transform:translateX(0)}}@keyframes slide-right-out_2c217{0%{opacity:1;transform:translateX(0)}to{opacity:0;transform:translateX(100px)}}@keyframes transform-enter_2c217{0%{transform:var(--transformStart_2c217)}to{transform:var(--transformEnd_2c217)}}@keyframes transform-exit_2c217{0%{transform:var(--transformEnd_2c217)}to{transform:var(--transformStart_2c217)}}.___SCollapse_2c217_gg_{transition-property:height;display:flow-root}",
    "2c217_gg_"
  ), {
    "@collapse-enter": "collapse-enter_2c217",
    "@collapse-exit": "collapse-exit_2c217",
    __SCollapse: "___SCollapse_2c217_gg_",
    "@fade-in-out-enter": "fade-in-out-enter_2c217",
    "@fade-in-out-exit": "fade-in-out-exit_2c217",
    "@opacity-in": "opacity-in_2c217",
    "@opacity-out": "opacity-out_2c217",
    "@scale-left-in": "scale-left-in_2c217",
    "@scale-right-in": "scale-right-in_2c217",
    "@scale-top-in": "scale-top-in_2c217",
    "@scale-bottom-in": "scale-bottom-in_2c217",
    "@scale-left-out": "scale-left-out_2c217",
    "@scale-right-out": "scale-right-out_2c217",
    "@scale-top-out": "scale-top-out_2c217",
    "@scale-bottom-out": "scale-bottom-out_2c217",
    "@slide-top-in": "slide-top-in_2c217",
    "@slide-top-out": "slide-top-out_2c217",
    "@slide-bottom-in": "slide-bottom-in_2c217",
    "@slide-bottom-out": "slide-bottom-out_2c217",
    "@slide-left-in": "slide-left-in_2c217",
    "@slide-left-out": "slide-left-out_2c217",
    "@slide-right-in": "slide-right-in_2c217",
    "@slide-right-out": "slide-right-out_2c217",
    "@transform-enter": "transform-enter_2c217",
    "--transformStart": "--transformStart_2c217",
    "--transformEnd": "--transformEnd_2c217",
    "@transform-exit": "transform-exit_2c217"
  })
);
function f(r, p) {
  var s, m = e.useState(r.placement), n = d(m, 2), t = n[0], y = n[1], c = e.useMemo(function() {
    return t.startsWith("left") ? "scale-left" : t.startsWith("right") ? "scale-right" : t.startsWith("bottom") ? "scale-bottom" : t.startsWith("top") ? "scale-top" : "opacity";
  }, [t]), a = e.useRef(), _ = Y(p, a);
  return e.useEffect(function() {
    if (!(t && t !== "auto") && a.current) {
      var u = setTimeout(function() {
        if (a.current) {
          var i = a.current.dataset.popperPlacement;
          i && y(i);
        }
      }, 0);
      return function() {
        return clearTimeout(u);
      };
    }
  }, [r.visible]), s = x(o), /* @__PURE__ */ e.createElement(X, s.cn("Animation", l(l({
    ref: _
  }, r), {}, {
    keyframes: [o["@".concat(c, "-in")], o["@".concat(c, "-out")]]
  })));
}
f.displayName = "Scale";
const W = k(f);
export {
  W as default
};
